(function () {
  'use strict';

  angular.module('app.referral-analytics', [
    'app.referral-analytics.quickview',
    'app.referral-analytics.subject-grade-comparisons',
    'app.referral-analytics.teacher-comparisons',
    'app.referral-analytics.teacher-details',
  ]);

})();